import { GameSurfaceIntegrated } from "../../state/GameSurfaceVisibility";
import { useContext, useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight, Eye } from "lucide-react";
import { analectById, cleanTranslation, quoteLabel, stripNoteMarks } from "../../engine";
import { useGame } from "../../state/GameProvider";

import { useDialog } from "../../lib/useDialog";
import { AutoAdvance } from "../challenge/AutoAdvance";

export function VictoryBanner() {
  const integrated = useContext(GameSurfaceIntegrated);
  const { state, actions } = useGame();
  const [dismissedId, setDismissedId] = useState<number | null>(null);

  const dialogRef = useRef<HTMLElement>(null);
  const analect = analectById.get(state.duel.analectId);
  const show =
    state.view === "duel" &&
    state.duel.status === "won" &&
    !state.duel.challenge &&
    analect !== undefined &&
    state.justWonId === state.duel.analectId &&
    dismissedId !== state.duel.analectId;

  useEffect(() => {
    if (state.duel.status !== "won") setDismissedId(null);
  }, [state.duel.analectId, state.duel.status]);

  useDialog(dialogRef, show, state.duel.analectId, () => setDismissedId(state.duel.analectId));

  return (
    <AnimatePresence>
      {show && analect && (
        <motion.div
          className="overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setDismissedId(state.duel.analectId)}
        >
          <motion.section
            className="victory"
            ref={dialogRef}
            tabIndex={-1}
            role="dialog"
            aria-modal={!integrated}
            aria-label="本則戰果"
            initial={{ opacity: 0, y: 22, scale: 0.92 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.96 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
            onClick={(event) => event.stopPropagation()}
          >
            <span className="vic-seal" aria-hidden>
              破
            </span>
            <h2>{integrated ? "四門練習完成" : "本則已掌握"}</h2>
            {integrated && <p className="reading-note">這次練習已完成。之後再回來複習，看看理解是否仍然清楚。</p>}
            <p className="vic-label">{quoteLabel(analect)} · 四門皆破</p>
            <blockquote className="vic-quote">{stripNoteMarks(analect.text)}</blockquote>
            <p className="vic-trans">{cleanTranslation(analect.translation)}</p>
            <AutoAdvance advance={() => actions.continueVictory(state.duel.analectId)} />
            <div className="vic-actions">
              <button className="vic-stay" onClick={() => setDismissedId(state.duel.analectId)}>
                <Eye size={15} />
                留看本則
              </button>
              <button className="vic-next" onClick={() => actions.continueVictory(state.duel.analectId)}>
                <span>下一則</span>
                <ArrowRight size={16} />
              </button>
            </div>
          </motion.section>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
